<div class="{{ containerClass }}">
    <span [ngClass]="'sera__label'">{{ label ? (label | translate) : '' }}:</span>
    <span
        *ngIf="value"
        [ngClass]="'sera__value'"
        >{{ value }}</span
    >
    <span
        *ngIf="valueDescription"
        [ngClass]="'sera__value__description'"
        >{{ valueDescription | translate }}</span
    >
</div>
